import "babel-polyfill";
import jquery from 'jquery';
import './css/app.css';
var React = require('react');
var $ = (typeof window !== 'undefined') ? window.$ = window.jQuery = jquery : {};
var jQueryBridget = require('jquery-bridget');
var Masonry = require('masonry-layout');
// eslint-disable-next-line
var foundation = require('foundation-sites');
var	ReactDOM = require('react-dom');
var browserHistory = require('react-router').browserHistory;
var syncHistoryWithStore = require('react-router-redux').syncHistoryWithStore;
var	Provider = require('react-redux').Provider;
var configureStore = require('./common/modules/store').configureStore;
var	routes = require('./common/routes/routes.jsx');
var prevLocation = {};

browserHistory.listen(function (location) {
    if (location.pathname !== prevLocation.pathname) {
      if (typeof window !== 'undefined') {
        var dataLayer = window.dataLayer;
        dataLayer.push({
            'event':'VirtualPageview',
            'virtualPageUrl': location.pathname
        });
      }
      prevLocation = location;
    }
});

var initialState = window.__STATE__;
var store = configureStore(initialState, browserHistory);
var history = syncHistoryWithStore(browserHistory, store);

$('').foundation(); // main purpose is for initing Foundation.MediaQuery

jQueryBridget('masonry', Masonry, $);

ReactDOM.render(
	<Provider store={store}>
		{ routes(history) }
	</Provider>,
	document.getElementById("application")
);



// WEBPACK FOOTER //
// ./src/index.js